const commonIp = '//api.linyouquan.net'
// const commonIp = '//dev.linyouquan.net'

import { fetchPost, fetchGet } from '@/utils/api'
function setCookie(c_name, value, expire) {
    var date = new Date()
    date.setSeconds(date.getSeconds() + expire)
    document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString()
}

const delCookie = function (c_name) {
    setCookie(c_name, "", -1)
}

const getWebsiteInfo = () => {
    const webEnvList = [
        {
            street_id: "wj",
            icp: "京ICP备05082545号",
            domain: "wang.linyouquan.net",
            site_name: "邻友圈",
            logo: "https://lyy.linyouquan.net/uploads/house/202203/25153351_305.png",
            site_id: 1
        },
        {
            street_id: "db",
            icp: "京ICP备05082545号",
            domain: "bjdongba.cn",
            site_name: "东坝网",
            logo: "https://lyy.linyouquan.net/uploads/house/202111/05141015_655.jpg",
            site_id: 2
        },
        {
            street_id: "110105000000",
            icp: "京ICP备05082545号-7",
            domain: "bjchaoyang.cn",
            site_name: "朝阳通",
            logo: "https://lyy.linyouquan.net/uploads/house/202201/12140458_699.png",
            site_id: 4
        },
        {
            street_id: "110112000000",
            icp: "京ICP备05082545号",
            domain: "bjtzh.top",
            site_name: "通州网",
            logo: "https://lyy.linyouquan.net/uploads/house/202203/21160433_656.jpg",
            site_id: 5
        },
        {
            street_id: "110108000000",
            icp: "京ICP备05082545号",
            domain: "bjhd.top",
            site_name: "海淀网",
            logo: "https://lyy.linyouquan.net/uploads/house/202203/21160402_49.jpg",
            site_id: 6
        },
        {
            street_id: "110113000000",
            icp: "京ICP备05082545号",
            domain: "bjshy.top",
            site_name: "顺义网",
            logo: "https://lyy.linyouquan.net/uploads/house/202203/21160344_884.jpg",
            site_id: 7
        },
        {
            street_id: "110115000000",
            icp: "京ICP备05082545号",
            domain: "bjdaxing.cn",
            site_name: "大兴网",
            logo: "https://lyy.linyouquan.net/uploads/house/202203/21160232_114.jpg",
            site_id: 8
        },
        {
            street_id: "110106000000",
            icp: "京ICP备05082545号",
            domain: "bjfengtai.cn",
            site_name: "丰台网",
            logo: "https://lyy.linyouquan.net/uploads/house/202203/21160114_736.jpg",
            site_id: 9
        },
        {
            street_id: "110114006000",
            icp: "京ICP备05082545号",
            domain: "bjchangping.cn",
            site_name: "昌平网",
            logo: 'https://lyy.linyouquan.net/uploads/house/202205/13101016_835.jpg',
            site_id: 3
        },
        {
          street_id: "110107000000",
          icp: "京ICP备05082545号-21",
          domain: "bjsjs.top",
          site_name: "石景山网",
          logo: 'https://lyy.linyouquan.net/uploads/house/202209/09151158_54.jpg',
          site_id: 10
        },
        {
          street_id: "bjdxch",
          icp: "京ICP备05082545号-20",
          domain: "bjdxch.cn",
          site_name: "北京东西城",
          logo: 'https://lyy.linyouquan.net/uploads/house/202209/09163649_535.jpg',
          site_id:11
        },
        {
            street_id: "",
            icp: "",
            domain: "10.3.8.215",
            site_name: "邻友圈",
            logo: "https://lyy.linyouquan.net/uploads/house/202203/25153351_305.png",
            site_id: 1
        }
    ]
    return webEnvList.find(item => window.location.href.indexOf(item.domain) > -1)
}
// async function  getWebsiteInfo(){
//     return new Promise((resolve,reject)=>{
//         fetchGet(`/pchome/sites`,{}).then((res)=>{
//             if(res.code ==200){
//                 let str_JsonDat=JSON.stringify(res.data.sites)
//                 localStorage.setItem('localSiteData',str_JsonDat)
//                 resolve(res.data.sites)
//             }
//         })
//     })
// }

// let siteData= async function(hlink){
//     let t =await getWebsiteInfo();
//     return t.find(item => hlink.indexOf(item.domain)>-1)
// }
export {
    commonIp,
    delCookie,
    getWebsiteInfo
    // siteData
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js